module.exports = __webpack_public_path__ + "static/media/path0302.0131f750.jpg";